import React from "react";
import { GangRunImpositionModal, type GangRunImpositionModalProps } from "./GangRunImpositionModal";

export type OrderDetailImpositionModalProps = GangRunImpositionModalProps;

/**
 * OrderDetailImpositionModal — Rule 2 Canonical Delegation Wrapper.
 * Ủy quyền 100% sang PrintLayoutModalContainer -> PrintLayoutForm.
 */
export function OrderDetailImpositionModal(props: OrderDetailImpositionModalProps) {
  return <GangRunImpositionModal {...props} />;
}
